<script>
  import LandingPage from "$lib/Landing/LandingPage.svelte";

  const description =
    "SmartClaim is an AI copilot for UK R&D tax advisors. It supercharges your expertise, making technical narrative writing faster, easier and more robust.";

  // Organization structured data, so search engines can show the name and logo.
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SmartClaim",
    url: "https://smartclaim.uk",
    logo: "https://smartclaim.uk/favicon.png",
    description,
  };
</script>

<svelte:head>
  <title>SmartClaim - AI for UK R&D tax relief consultants</title>
  <meta name="description" content={description} />
  <link rel="canonical" href="https://smartclaim.uk/" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://smartclaim.uk/" />
  <meta property="og:title" content="SmartClaim - AI for UK R&D tax relief consultants" />
  <meta property="og:description" content={description} />
  {@html `<script type="application/ld+json">${JSON.stringify(organization)}</script>`}
</svelte:head>

<LandingPage />
